module.exports = __webpack_public_path__ + "img/chek_box.60c66444.svg";